import FeedbackButton from "@/components/feedback/FeedbackButton";
import NotificationBell from "@/components/shared/NotificationBell";
import { ButtonShadcn as Button } from "@/components/ui/Button";
import ThemeToggleButton from "@/themes/ThemeToggleButton";
import { Menu } from "lucide-react";

const Header = ({ title = "", subTitle = "", onMenuClick }) => {
  return (
    <div className="flex gap-3 items-start w-full">
      <Button variant="ghost" size="icon" onClick={onMenuClick} aria-label="Open navigation menu" className="lg:hidden text-text-primary hover:bg-background-secondary">
        <Menu className="size-5" />
      </Button>
      <div className="flex justify-between items-start flex-1">
        <div>
          <h1 className="text-base sm:text-lg font-semibold leading-tight text-text-primary">{title}</h1>
          <p className="mt-0.5 text-xs leading-relaxed text-text-secondary">{subTitle}</p>
        </div>
        <div className="flex items-center gap-2">
          <ThemeToggleButton />
          <FeedbackButton />
          <NotificationBell />
        </div>
      </div>
    </div>
  );
};

export default Header;
